import styled from 'styled-components';
import { IContentWrapperProps } from 'store/ducks/Gaps/types';
import { variablesList } from 'constants/variablesList';

export const ContentWrapper = styled('div')<IContentWrapperProps>`
  width: 100%;
  padding: ${(props) => `${props.token.paddingLG}px`};

  .ant-tabs-nav {
    margin: unset;

    &::before {
      border-bottom: unset;
    }
  }
  .ant-table-content {
    border-radius: 10px;
  }
  .ant-table-thead tr .ant-table-cell {
    white-space: nowrap;
  }

  .ant-tabs {
    & > .ant-tabs-nav .ant-tabs-tab {
      border: unset;

      &:hover,
      &:focus,
      &:active {
        background: ${(props) => props.token.colorPrimaryBgHover};
        color: ${(props) => props.token.colorPrimaryText};
      }
    }

    .ant-tabs-nav-list {
      gap: 10px;
    }

    .ant-tabs-ink-bar {
      display: none;
    }

    .ant-tabs-tab {
      font-weight: bold;
      border-radius: 8px 8px 0 0;
      padding: 8px 16px;
      margin: unset;
      background: ${(props) => {
        if (props.scheme === 'turquoiseTheme') {
          return `${variablesList.turquoiseTheme.tabInactiveBackground} !important`;
        }
        return 'transparent';
      }};
      opacity: ${(props) => {
        if (props.scheme === 'turquoiseTheme') {
          return variablesList.turquoiseTheme.tabInactiveOpacity;
        }
        return '1';
      }};
      transition: all 0.2s ease;

      .ant-tabs-tab-btn {
        color: ${(props) => {
          if (props.scheme === 'turquoiseTheme') {
            return variablesList.turquoiseTheme.tabInactiveTextColor;
          }
          return props.token.colorText || '#000000';
        }};
        transition: color 0.2s ease;
      }

      &:hover,
      &:focus,
      &:active {
        background: ${(props) => {
          if (props.scheme === 'turquoiseTheme') {
            return variablesList.turquoiseTheme.tabHoverBackground;
          }
          return props.token.colorPrimaryBgHover;
        }};

        .ant-tabs-tab-btn {
          color: ${(props) => {
            if (props.scheme === 'turquoiseTheme') {
              return variablesList.turquoiseTheme.tabActiveTextColor;
            }
            return props.token.colorPrimaryText || '#ffffff';
          }};
        }
      }

      &.ant-tabs-tab-active {
        background: ${(props) => props.token.colorPrimaryBgHover} !important;
        opacity: 1;

        .ant-tabs-tab-btn {
          color: ${(props) => {
            if (props.scheme === 'turquoiseTheme') {
              return `${variablesList.turquoiseTheme.tabActiveTextColor} !important`;
            }
            if (
              props.scheme === 'greenModeTheme' ||
              props.scheme === 'eighthTheme'
            ) {
              return '#ffffff !important';
            }
            return props.token.colorPrimaryText || '#ffffff';
          }};
        }
      }
    }

    /* Force inactive tab styling for turquoise theme */
    ${(props) =>
      props.scheme === 'turquoiseTheme'
        ? `
      .ant-tabs-tab:not(.ant-tabs-tab-active) {
        background: ${variablesList.turquoiseTheme.tabInactiveBackground} !important;
      }
    `
        : ''}
  }
`;
